import { SVGProps, Ref, forwardRef } from 'react';

export const GoogleGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.143 3.707c1.34 0 2.246.567 2.762 1.042L12.92 2.82C11.682 1.692 10.071 1 8.143 1a7.15 7.15 0 0 0-6.381 3.858l2.31 1.758a4.31 4.31 0 0 1 4.07-2.91"
                    fill="#7F858B"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 8.156c0-.576-.048-.996-.15-1.432H8.142v2.598h3.936c-.079.646-.508 1.618-1.46 2.271l2.254 1.712C14.223 12.083 15 10.287 15 8.155"
                    fill="#8B9299"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.08 9.385A4.2 4.2 0 0 1 3.84 8c0-.482.088-.949.23-1.384l-2.31-1.758A6.9 6.9 0 0 0 1 8c0 1.128.278 2.193.762 3.142z"
                    fill="#A3ABB2"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.143 15c1.929 0 3.548-.622 4.73-1.695l-2.254-1.712c-.603.413-1.412.7-2.476.7A4.29 4.29 0 0 1 4.08 9.384l-2.31 1.758A7.14 7.14 0 0 0 8.143 15"
                    fill="#72777D"
                />
            </g>
        </g>
    </svg>
));
GoogleGrayscaleSize16Glyph.displayName = 'GoogleGrayscaleSize16Glyph';
